import React from "react";
import Text from "../../Text";

interface Props {
  description: string;
}

const SubHeader: React.FC<Props> = ({ description }) => {
  return (
    <Text
      px={16}
      py={10}
      size="sm"
      color="tertiary"
      style={{ borderBottom: "1px solid var(--color-border-secondary)" }}
    >
      {description}
    </Text>
  );
};

export default SubHeader;
